/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui'

export const useProductCardStyles = makeStyles()(theme => ({
  product: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: '265px',
    maxWidth: '225px',
    flexShrink: 0,
    margin: '12px',
    padding: 0,
    paddingBottom: '12px',
    position: 'relative',
  },
  productActive: {
    border: `1.5px solid ${theme.palette.primary.main}`,
    boxShadow: 'none',
  },
  activeLabel: {
    top: theme.spacing(2),
    left: theme.spacing(2),
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: '24px',
  },
  productImage: {
    margin: 0,
    padding: 0,
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    marginBottom: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  buttonContainer: {
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  button: {
    fontSize: '16px',
    padding: '16px 0px',
  },

  priceContainer: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  flexPrice: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  containerTextWrapper: {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  numCounter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconButtonBackwards: {
    background: theme.palette.grey.grey02,
    color: theme.palette.primary.contrastText,
    width: '32px',
    height: '32px',
    borderRadius: theme.shape.borderRadius,
  },
  iconButton: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    width: '32px',
    height: '32px',
    borderRadius: theme.shape.borderRadius,
  },
}))
